/**
 * Rate plan meal plan codes.
 *
 * The set of meal plan options a rate plan can advertise. Shared between the
 * pricing engine and the admin portal, so the labels and values cannot drift.
 */
export const RATE_PLAN_MEAL_PLANS = {
    NONE: 'NONE',
    BREAKFAST: 'BREAKFAST',
    HALF_BOARD: 'HALF_BOARD',
    FULL_BOARD: 'FULL_BOARD',
    ALL_INCLUSIVE: 'ALL_INCLUSIVE',
};
//# sourceMappingURL=rate-plan-meal-plans.js.map